<ion-header>
  <ion-toolbar color="medium">
    <ion-buttons slot="start">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>FOTO DE LA NOTA</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="borrarFoto()" [disabled]="imgBase64 === '' && foto === ''">
        <ion-icon slot="icon-only" name="trash"></ion-icon>
      </ion-button>
      <ion-button (click)="guardar()">
        <ion-icon slot="icon-only" name="checkmark-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-margin">
  <ion-card>
    <input class="ion-hide" type="file" accept="image/*" #camera (change)="resize($event)">
    @if (imageChangedEvent) {
      <div class="kblab-flex kblab-flex-dir-r ion-justify-content-center ion-align-items-center">
        <img [src]="imgBase64 || foto || shared.SINIMAGEN" (click)="takeFoto()" alt="foto">
      </div>
    } @else {
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        output="base64"
        format="png"
        (imageCropped)="image($event)"
      ></image-cropper>
    }
    @if (verEtiquetas && (foto !== '' || imgBase64 !== '')) {
      <ion-card-content>
        <ion-list>
          <ion-item>
            <ion-checkbox labelPlacement="start" [checked]="todos" mode="ios" (ionChange)="changeTodo($event)">
              TODOS ETIQUETADOS
            </ion-checkbox>
          </ion-item>
          @if (!todos) {
            <ion-item-group>
              @for (a of alumnos; track a.id) {
                <ion-item>
                  <ion-checkbox labelPlacement="start" [checked]="a.check" mode="ios" (ionChange)="change($event, a)">
                    {{a.nombre}} {{a.apellido1}} {{a.apellido2}}
                  </ion-checkbox>
                </ion-item>
              }
            </ion-item-group>
          }
        </ion-list>
      </ion-card-content>
    }
  </ion-card>
</ion-content>
